import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { CustomFormType, PreModerationPhraseSearchType } from '@campaign-portal/namespace/common/enums';
import { CustomEntityField, CustomForm } from '@campaign-portal/namespace/entities/custom-forms/specs';
import { PreModerationPhrase } from '@campaign-portal/namespace/entities/premoderation-phrases/specs';

export interface CustomFormEntityConfig<ID = exist | creating> extends Partial<CustomForm<ID>> {
	id: ID;
}

export class CustomFormEntity<ID = exist | creating> implements CustomForm<ID> {
	id: ID;
	type: CustomFormType;
	fields: CustomEntityField[];
	ccId?: Id<exist>;
	readonly creationDate?: string | null;
	readonly lastUpdated?: string | null;
	readonly modifiedBy?: string | null;
	readonly createdBy?: string | null;

	constructor(config: CustomFormEntityConfig<ID>) {
		this.id = config.id;
		this.type = config.type ?? CustomFormType.SIGN_UP_FORM;
		this.fields = config.fields ?? [];
		this.ccId = config.ccId;
		this.creationDate = config.creationDate;
		this.lastUpdated = config.lastUpdated;
		this.modifiedBy = config.modifiedBy;
		this.createdBy = config.createdBy;
	}
}

export interface PreModerationPhraseEntityConfig<ID = exist | creating> extends Partial<PreModerationPhrase<ID>> {
	id: ID;
}

export class PreModerationPhraseEntity<ID = exist | creating> implements PreModerationPhrase<ID> {
	id: ID;
	text: string;
	searchType: PreModerationPhraseSearchType;
	readonly creationDate?: string | null;
	readonly lastUpdated?: string | null;

	constructor(config: PreModerationPhraseEntityConfig<ID>) {
		this.id = config.id;
		this.text = config.text ?? '';
		this.searchType = config.searchType ?? PreModerationPhraseSearchType.EVERYWHERE;
		this.creationDate = config.creationDate;
		this.lastUpdated = config.lastUpdated;
	}
}
